module.exports = "<div class=shifts> <shift data=shift driver-holiday=vm.driverHoliday ng-repeat=\"shift in vm.shifts\" ng-style=\"{'margin-top': shift.offset * 10 + 'px', 'margin-bottom': shift.tail * 10 + 'px'}\" ng-class=\"{ 'not-preferred': !shift.preferred, 'violation': shift.violations.length > 0, 'warning': shift.warnings.length > 0, 'allocated': shift.isAssigned, 'past': vm.isDisabled}\"> </shift> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/planner/day/template.html
// module id = 211
// module chunks = 0